import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import * as message from "../../config/CommonMessages";
import { checkObjExists } from "../Common/Common";

class FooterPublic extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  findFormErrors = () => {
    const newErrors = {};
    let trans = this.props.transaction;
    if (trans) {
      if (!trans.clientFirstName || trans.clientFirstName.trim() === "") {
        newErrors.clientFirstName = message.ENTER_FIRST_NAME;
      }
      if (trans.clientFirstName) {
        if (!trans.clientFirstName.match("^[A-Za-z '-]{1,50}$")) {
          newErrors.clientFirstName = message.ENTER_VALID_FIRST_NAME;
        }
      }
      if (trans.clientLastName) {
        if (!trans.clientLastName.match("^[A-Za-z '-]{1,50}$")) {
          newErrors.clientLastName = message.ENTER_VALID_LAST_NAME;
        }
      }
      if (trans.clientEmail) {
        if (
          !trans.clientEmail.match(
            "^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$"
          )
        ) {
          newErrors.clientEmail = message.ENTER_VALID_EMAIL;
        }
      }
      if (trans.clientPhone) {
        let clientMobile = trans.clientPhone.replace(/-/g, "");
        if (clientMobile.length !== 10) {
          newErrors.clientPhone = message.ENTER_VALID_MOBILE;
        }
      }
      if (trans.hasGuardian) {
        if (!trans.guardianName || trans.guardianName.trim() === "") {
          newErrors.guardianName = message.ENTER_NAME;
        }
        if (trans.guardianName) {
          if (!trans.guardianName.match("^[A-Za-z '-]{1,50}$")) {
            newErrors.guardianName = message.ENTER_VALID_NAME;
          }
        }
        if (trans.guardianEmail) {
          if (
            !trans.guardianEmail.match(
              "^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$"
            )
          ) {
            newErrors.guardianEmail = message.ENTER_VALID_EMAIL;
          }
        }
        if (trans.guardianPhone) {
          let guardianMobile = trans.guardianPhone.replace(/-/g, "");
          if (guardianMobile.length !== 10) {
            newErrors.guardianPhone = message.ENTER_VALID_MOBILE;
          }
        }
      }
    }
    return newErrors;
  };

  render() {
    return (
      <div>
        {this.props.form === "intake" ||
        this.props.form === "consent" ||
        this.props.form === "checkin" ? (
          <Row>
            <Col xs={12} sm={7}>
              <Button
                variant="primary"
                style={{ marginLeft: "20px" }}
                className="text-uppercase sticky-header-btn mb-5"
                onClick={() => {
                  const newErrors = this.findFormErrors();
                  if (checkObjExists(newErrors)) {
                    this.props.errorHandler(newErrors);
                  } else {
                    this.props.errorHandler(newErrors);
                    this.props.exportFormToPDF();
                  }
                }}
              >
                Submit Form
              </Button>
            </Col>
          </Row>
        ) : this.props.form === "aftercare" ? (
          <Row>
            <Col xs={12} sm={7}>
              <Button
                style={{ marginLeft: "20px" }}
                variant="primary"
                className="text-uppercase sticky-header-btn mb-5"
                onClick={() => {
                  const newErrors = this.findFormErrors();
                  if (checkObjExists(newErrors)) {
                    this.props.errorHandler(newErrors);
                  } else {
                    this.props.errorHandler(newErrors);
                    this.props.exportFormToPDF();
                  }
                }}
              >
                Download Form
              </Button>
            </Col>
          </Row>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default FooterPublic;
